var _defs, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _polygon3, _polygon4, _polygon5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTipsport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "4500 13007 12000 3686",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n            .fil0 {fill:#2197F4}\n            .fil1 {fill:#F59A00}\n            .fil3 {fill:#FEFEFE}\n            .fil2 {fill:#FEFFFF}\n\n        "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "4500,13007 16500,13007 16500,16693 4500,16693 ",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "7505,13688 6042,15864 5418,13885 6242,14439 ",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M9510 15346c34,-226 44,-295 102,-678 18,-12 115,-24 141,-25 372,-7 292,427 191,579 -85,128 -176,173 -434,124zm-38 285c210,29 373,44 553,-54 140,-77 239,-189 303,-359 149,-396 56,-773 -346,-849 -178,-34 -432,-9 -598,37 -89,25 0,0 -98,30 -246,1644 -38,255 -240,1608l359 -3c17,-104 46,-280 67,-410z",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M13658 15007c-74,461 -400,409 -479,276 -42,-72 -43,-177 -33,-268 19,-172 101,-344 263,-368 222,-33 281,160 249,360zm359 0c35,-204 -29,-383 -128,-498 -182,-214 -979,-338 -1105,501 -60,401 165,683 611,650 393,-29 558,-283 622,-653z",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M11414 14398c-187,-55 -502,-66 -676,3 -269,107 -375,455 -12,685 60,38 382,181 224,265 -46,25 -114,26 -169,25 -58,-1 -122,-6 -178,-15 -47,-7 -89,-11 -159,-25 -39,207 -2,13 -52,277 259,64 740,112 907,-145 53,-81 78,-208 44,-307 -59,-172 -268,-255 -420,-352 -133,-85 -53,-164 99,-168 129,-4 234,27 346,36l46 -279z",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M15386 14006l-376 133c-58,327 -100,668 -152,1004 -27,180 -52,358 77,448 153,107 447,57 473,36 19,-115 32,-190 51,-301 -268,22 -263,-28 -233,-230 10,-69 51,-398 69,-434 14,-16 249,-8 267,-8l36 -272 -264 -2 52 -374z",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M14853 14645c30,-187 21,-125 45,-285 -225,-37 -471,30 -660,103 -63,411 -116,780 -174,1171l356 -1 142 -958c91,-30 198,-38 291,-30z",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "7608,14276 7649,13990 8664,13989 8624,14272 8317,14276 8112,15628 7740,15632 7943,14276 ",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "9068,14382 8714,14385 8529,15634 8885,15632 ",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "9089,14275 8731,14276 8772,13989 9130,13990 ",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M11813 15340c34,-226 55,-367 102,-677 18,-12 115,-24 141,-25 372,-8 292,427 191,578 -86,129 -176,173 -434,124zm-42 285c210,29 377,44 557,-54 140,-76 239,-188 303,-358 149,-397 56,-774 -346,-850 -178,-33 -432,-8 -598,38 -89,24 0,0 -98,30 -246,1643 -38,255 -241,1607l360 -2c17,-104 42,-281 63,-411z",
    transform: "matrix(1, 0, 0, 1, 4.547473508864641e-13, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTipsport);
export default __webpack_public_path__ + "static/media/logo_tipsport.80e8b39cd24f8a5c398eb020f51a1d6c.svg";
export { ForwardRef as ReactComponent };